import React, { useEffect, useState } from "react";
import { Modal, Button, Input, Form, DatePicker } from "antd";
import IntlCurrencyInput from "react-intl-currency-input";
import './style.css';
import paymentService from "../../service/payment.service";
import DialogDeConfirmação from "../dialog-confirm/dialogDeConfirmação";
import moment from "moment";
import driverService from "../../service/driver.service";
import freightService from "../../service/freight.service";
import { useSelector } from "react-redux";

const PaymentModal = ({ view, visible, onClose, driverName, dataHistory, type, onUpdate }) => {
  const [form] = Form.useForm();

  const user = useSelector(state => state.user);

  const [record, setRecord] = useState('');
  const [dataHistoryy, setDataHistory] = useState('');

  const [idFreight, setIdFreight] = useState('');
  const [idDriver, setIdDriver] = useState('');
  const [driverRecord, setDriverRecord] = useState([]);
  const [freightRecord, setFreightRecord] = useState([]);

  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDialogErro, setOpenDialogErro] = React.useState(false);
  const [erroMessage, setErroMessage] = React.useState("");
  const [message, setMessage] = React.useState("");

  const [formDisabled, setFormDisabled] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const [btnLoading, setBtnLoading] = useState(false);

  const currencyConfig = {
      locale: "pt-BR",
      formats: {
          number: {
              BRL: {
                  style: "currency",
                  currency: "BRL",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              },
          },
      },
  };

  useEffect(() => {
    if (driverName) {
      setRecord(driverName);
      setDataHistory(dataHistory);
    }
  }, [driverName, dataHistory]);
  
  useEffect(() => {
    if (record) {
      // Verifica se 'record' contém 'idFreight', senão tenta pegar de 'driverName'
      setIdFreight(record?.idFreight || driverName?.idFreight || null);
      setIdDriver(driverName?.driverID || null);
      // debugger;
    }
  }, [record, driverName]);

  useEffect(() => {
    if (record) {
      const timestamp = moment(dataHistoryy?.initialDate?.seconds * 1000 + Math.floor(dataHistoryy?.initialDate?.nanoseconds / 1_000_000));
      const timestamp2 = moment(dataHistoryy?.initialDateContrate?.seconds * 1000 + Math.floor(dataHistoryy?.initialDateContrate?.nanoseconds / 1_000_000));
      // const timestamp3 = moment(dataHistoryy.initialDate.seconds * 1000 + Math.floor(dataHistoryy.initialDate.nanoseconds / 1_000_000));
      form.setFieldsValue({
        dataEmissao: timestamp ? moment(timestamp, "DD/MM/YYYY") : timestamp2 ? moment(timestamp2, "DD/MM/YYYY") : "",
        status: record.status || undefined,
        obs: record.obs || "",
        valorAdicional: record.valorAdicional || 0,
        desconto: record.desconto || 0,
        dataVencimento: record.dataValidade ? moment(record.dataValidade, "DD/MM/YYYY") : null,
      });

      if (!user?.permissoes?.payment?.isEdit && !user?.permissoes?.payment?.editar) {
        const onlyView = true;
        setFormDisabled(onlyView);
        setButtonDisabled(onlyView);
      }
      else {
        const onlyView = false;
        setFormDisabled(onlyView ? onlyView : record.status?.toLowerCase() === 'pago');
        setButtonDisabled(onlyView);
      }
    }
  }, [record, form]);

  const onFinish = async (values) => {

    if (!idFreight) {
      console.error("Erro: ID do frete não foi fornecido!");
      return;
    }

    try {
      const formattedDataAtt = values?.dataBaixa ? values.dataBaixa.format("DD/MM/YYYY") : null;
      await paymentService.update({ 
        idFreight,
        // id: record.id || record?.idFreight + record?.value,
        type: record.type,
        status: values?.status,
        obs: values?.obs,
        valueTotal: Number(record.value) + Number(values?.valorAdicional ?? 0) - Number(values?.desconto ?? 0),
        value: record?.value,
        valorAdicional: Number(values?.valorAdicional || 0),
        desconto: Number(values?.desconto || 0),
        dataBaixa: values?.status?.toLowerCase() === "pago" ? formattedDataAtt : null,
        dataValidade: values?.dataVencimento ? values.dataVencimento.format("DD/MM/YYYY") : null,
      });
      setOpenDialog(true);
      form.resetFields();
    } catch (error) {
      console.error("Erro ao salvar status:", error);
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setOpenDialogErro(false);
    onUpdate(); // Executa a atualização ao fechar o diálogo
  };

  const resetFormToOriginal = () => {
    if (!record) return;
    const timestamp = moment(dataHistoryy?.initialDate?.seconds * 1000 + Math.floor(dataHistoryy?.initialDate?.nanoseconds / 1_000_000));
    const timestamp2 = moment(dataHistoryy?.initialDateContrate?.seconds * 1000 + Math.floor(dataHistoryy?.initialDateContrate?.nanoseconds / 1_000_000));
    form.setFieldsValue({
      dataEmissao: timestamp ? moment(timestamp, "DD/MM/YYYY") : timestamp2 ? moment(timestamp2, "DD/MM/YYYY") : "",
      status: record.status || undefined,
      obs: record.obs || "",
      valorAdicional: record.valorAdicional || 0,
      desconto: record.desconto || 0,
      dataVencimento: record.dataValidade ? moment(record.dataValidade, "DD/MM/YYYY") : null,
      dataBaixa: record?.dataBaixa ? moment(record.dataBaixa, "DD/MM/YYYY") : null,
    });
    if (!user?.permissoes?.payment?.isEdit && !user?.permissoes?.payment?.editar) {
      setFormDisabled(true);
      setButtonDisabled(true);
    } else {
      setFormDisabled(record.status?.toLowerCase() === 'pago');
      setButtonDisabled(false);
    }
  };

  const handleClose = () => {
    resetFormToOriginal();
    onClose();
  };

  const valorAdicionalRaw = Form.useWatch('valorAdicional', form);
  const descontoRaw = Form.useWatch('desconto', form);
  const status = Form.useWatch('status', form);
  const valorAdicionall = Number(valorAdicionalRaw) || 0;
  const descontoo = Number(descontoRaw) || 0;  
  const valorTotal = (record?.value || 0) + (valorAdicionall || 0) - (descontoo || 0);

  useEffect(() => {
    if (!record) return;

    if (!form) return;

    if (record?.dataBaixa) {
      form.setFieldsValue({ dataBaixa: moment(record.dataBaixa, "DD/MM/YYYY") });
    } 
    else {
      form.setFieldsValue({ dataBaixa: null });
    }

  }, [record, status, form]);

  const handleSearchInfo = async (idDriver, idFreight) => {
    let driverData = null;
    let freightData = null;
    
    if (!idDriver || !idFreight) {
      console.error("Erro: ID do motorista ou do frete não foi fornecido!");
      return { driverData, freightData };
    }

    try {
      await driverService.getDriverAvailable(idDriver)
        .then( async (doc) => {
          if (doc.exists) {
            driverData = {
              ...doc.data(),
              driver: doc.data().name || "Motorista não encontrado",
              type: type || "Tipo não definido",
              value: dataHistory?.value || 0,
            };

            const documentsSnapshot = await driverService.getDriverDocuments(idDriver);
            const documents = [];
            documentsSnapshot.forEach((doc) => {
              documents.push({ id: doc.id, ...doc.data() });
            });

            driverData.documents = documents;
            setDriverRecord(driverData);
          } else {
            console.error("Motorista não encontrado");
          }
        });
    }
    catch (error) {
      console.error("Erro ao buscar informações:", error);
    }

    try {
      await freightService.getFreightById(idFreight)
        .then((doc) => {
          if (doc.exists) {
            freightData = { ...doc.data() };
            setFreightRecord(freightData);
          } else {
            console.error("Frete não encontrado");
          }
        });
    }
    catch (error) {
      console.error("Erro ao buscar informações:", error);
    }
    return { driverData, freightData };
  }

  const handleCreateHtml = async (dadoDriver, dataFreight, Subject, obs, valorSolicitado, valorOriginal, valorAdicional, valorDesconto, type) => {
    if (!dadoDriver || !dataFreight) {
      console.error("Erro: Dados insuficientes para criar HTML!");
      return;
    }

    await paymentService.prepareEmail(
        dadoDriver,  
        dataFreight,
        Subject,
        obs,
        valorSolicitado,
        valorOriginal,
        valorAdicional,
        valorDesconto,
        type,
        user,
      );

  }


  return (
    <>
    <Modal
      title="Baixa Pagamento - Informação do Frete"
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="cancel" onClick={handleClose}>
          Cancelar
        </Button>,
        <Button disabled={buttonDisabled} type="primary" loading={btnLoading} onClick={async () => {
          if (formDisabled) {
            // Reativa os campos
            setFormDisabled(false);
            return;
          }

          try {
            // 1. Validações de valores alterados
            const valorAdicionalOriginal = record.valorAdicional ?? 0;
            const descontoOriginal = record.desconto ?? 0;
            const valorAdicionalAtual = form.getFieldValue('valorAdicional') ?? 0;
            const descontoAtual = form.getFieldValue('desconto') ?? 0;

            const houveMudancaValores = valorAdicionalOriginal !== valorAdicionalAtual || descontoOriginal !== descontoAtual;

            const obsAtual = form.getFieldValue('obs');

            // 2. Valida status
            const statusAtual = form.getFieldValue('status');
            if (!statusAtual || statusAtual === "") {
              setOpenDialogErro(true);
              setErroMessage("Erro no formulário!");
              setMessage(<>Por favor, selecione um <b>status</b> válido.</>);
              return;
            }

            await form.validateFields();

            // 3. Envio de email (se necessário)
            let emailEnviadoComSucesso = true;
            const statusAnterior = record?.status?.toLowerCase();

            if (statusAtual === 'solicitar pagamento') {
              setBtnLoading(true);

              try {
                const { driverData, freightData } = await handleSearchInfo(idDriver, idFreight);

                if (!driverData || !freightData) {
                  throw new Error("Dados do motorista ou frete não encontrados");
                }

                // Determina se é Errata ou Solicitação normal
                // Errata: se JÁ estava em "solicitar pagamento" E houve mudança de valores
                const isErrata = statusAnterior === 'solicitar pagamento' && (houveMudancaValores || obsAtual !== record.obs || record.dataVencimento !== form.getFieldValue('dataVencimento'));
                const assunto = isErrata ? "Errata! Solicitação de Pagamento" : "Solicitação de Pagamento";

                await handleCreateHtml(
                  driverData,
                  freightData,
                  assunto,
                  obsAtual || record.obs,
                  valorTotal,
                  record?.value,
                  valorAdicionalAtual,
                  descontoAtual,
                  record.type
                );
              } catch (emailError) {
                console.error("Erro no envio do e-mail:", emailError);
                emailEnviadoComSucesso = false;
                form.setFieldsValue({ status: record?.status ?? undefined });
                setOpenDialogErro(true);
                setErroMessage("Erro no envio do e-mail");
                setMessage(<>Não foi possível enviar o e-mail de solicitação de pagamento. O status foi revertido para <b>{record?.status || "anterior"}</b>. Tente novamente.</>);
              } finally {
                setBtnLoading(false);
              }
            }

            // 4. Só submete se o email foi enviado com sucesso (ou se não era necessário enviar email)
            if (emailEnviadoComSucesso) {
              form.submit();
              onClose();
            }
          } catch (errorInfo) {
            console.error("Erro de validação:", errorInfo);
            setBtnLoading(false);
          }
        }}>
          {formDisabled ? buttonDisabled ? "Salvar" : "Desfazer Baixa" : "Salvar"}
        </Button>,
      ]}
      width={700}
    >
      <Form form={form} onFinish={onFinish} style={{ paddingLeft: '4%', display: 'flex', alignItems: 'flex-start', border: 'none', cursor: 'default' }}>

        <div className="formMotoType">
          <div className="formMotorista" >
            <Form.Item /* label="Motorista" */>
              {/* <span>{record ? record.driver : "Erro na busca do Motorista"}</span> */}
              <input className="form-control my-2" placeholder={record ? record.driver : "Erro na busca do Motorista"} disabled />
            </Form.Item>
          </div>

          <div className="tipoType">
            <div> <p>Descrição: </p> </div>
            <Form.Item /* label="Tipo" */ style={{ width: '207px' }} disabled>
              {/* <span>{type}</span> */}
              <input className="form-control my-2" placeholder={record.type} disabled />
            </Form.Item>
          </div>
        </div>

        <div className="formValOriStatus" >
          <div className="valorOriginal">
            <Form.Item /* label="Valor Original" */ name="valorOriginal" >
              <div> <p>Valor Original:</p> </div>
              <IntlCurrencyInput
                id="InputDinero"
                currency="BRL"
                config={currencyConfig}
                defaultValue={record?.value ?? 0}
                className="form-control my-2"
                disabled
              />
            </Form.Item>
          </div>

          <div className="formStatus" >
            <Form.Item /* label="Status" */ name="status" >
              <select disabled={formDisabled} className="form-select" >
                <option value="">Selecione o Status</option>
                <option value="bloqueado">Bloqueado</option>
                <option value="pendente">Pendente Liberação</option>
                <option value="solicitar pagamento">Solicitar Pagamento</option>
                <option value="pago">Pago</option>
                <option value="cancelado">Cancelado</option>
              </select>
            </Form.Item>
          </div>
        </div>

        <div className="tipo">
          <div>
            <div> <p>Valor Adicional: </p> </div>
            <Form.Item /* label="Valor Adicional" */ name="valorAdicional">
              <IntlCurrencyInput
                disabled={formDisabled}
                id="InputDinero"
                currency="BRL"
                config={currencyConfig}
                value={form.getFieldValue('valorAdicional') ?? 0}
                className="form-control my-2"
                onChange={(event, value, maskedValue) => {
                  form.setFieldsValue({ valorAdicional: value });
                }}
              />
            </Form.Item>
          </div>

          <div className="formDataAtt">
            <div> <p>Data de Emissão: </p> </div>
            <Form.Item name="dataEmissao" >
              <DatePicker placement="bottomRight" format="DD/MM/YYYY" style={{ width: '100%' }} disabled />
            </Form.Item>
          </div>
        </div>

        <div className="formDescVencimento" >
          <Form.Item /* label="Desconto" */ name="desconto">
            <div>
              <p>Desconto: </p>
            </div>
            <IntlCurrencyInput
              disabled={formDisabled}
              id="InputDinero"
              currency="BRL"
              config={currencyConfig}
              value={form.getFieldValue('desconto') ?? 0}
              className="form-control my-2"
              onChange={(event, value, maskedValue) => {
                form.setFieldsValue({ desconto: value });
              }}
            />
          </Form.Item>

          <div className="formDataVencimento">
            <div> <p>Data de Vencimento: </p> </div>
            <Form.Item name="dataVencimento" >
              <DatePicker disabled={formDisabled} format="DD/MM/YYYY" style={{ width: "208px", marginTop: "10px" }} getPopupContainer={trigger => trigger.parentNode} dropdownClassName="custom-date-picker-popup" />
            </Form.Item>
          </div>
        </div>

        <div className="valorDataBaixa">
          <div>
            <div> <p>Total: </p> </div>
            <Form.Item /* label="Valor" */>
              {/* <span>{record ? `R$ ${record.value}` : "Erro na busca do valor do frete"}</span> */}
              <input style={{ width: "208px" }} className="form-control my-2" placeholder={ Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL' }).format(valorTotal) } disabled />
            </Form.Item>
          </div>

          <div className="formDataBaixa">
            <div> <p>Data da Baixa: </p> </div>
            <Form.Item
              name="dataBaixa"
              rules={[
                {
                  validator: (_, value) => {
                    const currentStatus = form.getFieldValue('status');
                    if ((currentStatus || '').toLowerCase() === 'pago') {
                      return value ? Promise.resolve() : Promise.reject(new Error("Por favor, selecione a data"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <DatePicker placement="bottomRight" format="DD/MM/YYYY" style={{ width: '208px', marginTop: "10px" }} disabled={status !== "pago" || formDisabled} getPopupContainer={trigger => trigger.parentNode} dropdownClassName="custom-date-picker-popup" />
            </Form.Item>
          </div>
        </div>

        <div className="tipoObs2">
          <div> <p>Observações: </p> </div>
          <Form.Item name="obs" >
            {/* <Input className="InputTypeText" type="text" placeholder="Digite sua Observação" /> */}
            <Input.TextArea disabled={formDisabled} className="InputTypeText" placeholder={"Digite sua Observação"} style={{ width: '400px' }} />
          </Form.Item>
        </div>
      </Form>
    </Modal>

    <DialogDeConfirmação
      open={openDialog}
      handleClose={handleDialogClose}
      title="Confirmado!"
      message="O pagamento foi solicitado com sucesso."
      status="success"
    />
    <DialogDeConfirmação
      open={openDialogErro}
      handleClose={handleDialogClose}
      title={erroMessage}
      message={message}
      status="error"
    />
    </>
  );
};

export default PaymentModal;
